module.exports = __webpack_public_path__ + "img/53.b5e0f51c.jpg";